module.exports = __webpack_public_path__ + "img/рз_36.05d7b1f9.png";